"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentRegexCsvActions = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var departmentRegexCsvUpload_1 = require("./departmentRegexCsvUpload");
var departmentRegexCsvDownload_1 = require("./departmentRegexCsvDownload");
var DepartmentRegexCsvActions = function (props) {
    var departments = props.departments, onApply = props.onApply, onCsvLoadingChange = props.onCsvLoadingChange;
    var _a = __read(react_1.default.useState([]), 2), errors = _a[0], setErrors = _a[1];
    var handleLoadingChange = react_1.default.useCallback(function (isLoading) {
        onCsvLoadingChange === null || onCsvLoadingChange === void 0 ? void 0 : onCsvLoadingChange(isLoading);
    }, [onCsvLoadingChange]);
    var handleErrorsChange = react_1.default.useCallback(function (nextErrors) {
        setErrors(nextErrors);
    }, []);
    var handleDismissErrors = react_1.default.useCallback(function () {
        setErrors([]);
    }, []);
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(departmentRegexCsvUpload_1.DepartmentRegexCsvUpload, { departments: departments, onApply: onApply, onLoadingChange: handleLoadingChange, onErrorsChange: handleErrorsChange }),
        react_1.default.createElement(departmentRegexCsvDownload_1.DepartmentRegexCsvDownload, { departments: departments }),
        react_1.default.createElement(departmentRegexCsvUpload_1.DepartmentRegexCsvUploadHints, { errors: errors, onDismiss: handleDismissErrors })));
};
exports.DepartmentRegexCsvActions = DepartmentRegexCsvActions;
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  gap: 8px;\n  margin-bottom: 12px;\n  align-items: start;\n"], ["\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  gap: 8px;\n  margin-bottom: 12px;\n  align-items: start;\n"])));
var templateObject_1;
